export default __webpack_public_path__ + "static/media/groove-logo.1b9b4bbc.svg";